<template>
  <header class="z-header">
    <div class="container flex flex-v-center">
      <a class="logo" href="#"></a>
      <h1 class="site-title">LOGO下载平台</h1>
      <h4 class="update-info">update 2023/03/02</h4>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.z-header {
  height: 60px;
  background: #444444;
  border: 1px solid rgba(0, 0, 0, 0.06);
  .container {
    height: 60px;
  }
  .logo {
    display: block;
    width: 128px;
    height: 27px;
    background: url('../assets/ziroom_logo_slogan_white.png') no-repeat 0 0 /
      100% 100%;
    transform: translateY(-4px);
  }
  .site-title {
    margin: 0 10px 0 10px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0.25px;
    line-height: 16px;
  }
  .update-info {
    margin-top: 5px;
    font-style: italic;
    font-family: HelveticaNeue;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.3);
    letter-spacing: 0.16px;
    line-height: 16px;
  }
}
</style>
